import { EventColorCategory } from "@clockwise/client-commons/src/util/event-category-coloring";
import { negate } from "lodash";

export const hasCategoryOutOfOffice = ({ eventCategory }: { eventCategory?: EventColorCategory }) =>
  eventCategory === "OutOfOffice";
export const hasNoCategoryOutOfOffice = negate(hasCategoryOutOfOffice);
